module.exports = __webpack_public_path__ + "img/cal.68312493.svg";